import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Table, Button, Col, Row, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import * as XLSX from 'xlsx';
import Header from "../Layout/Header/Header";
import BotComment from "../CommentsList.jsx/BotComment";
import DisableUser from "../Delete/DisableUser";
import SobreTurno from "../Apointment/SobreTurno";
import exportFromJSON from "export-from-json";
import Expediente from "../Formulario/Expediente";
import ReactLoading from 'react-loading'
import dayjs from "dayjs";
import "../../index.css";
import './List.css'
import '../Formulario/Expediente.css'
import { TableVirtuoso } from 'react-virtuoso'
import Swal from "sweetalert2";
import Cuenta from "../Cuenta";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function List(props) {
  let { isAuth, user1 } = useContext(AuthContext);
  let [data1, setData1] = useState([]);
  let [dataxls, setDataxls] = useState([]);
  let order
  let [list, setList] = useState(props.lista);
  let [users, setUsers] = useState([]);
  let [doctores, setDoctores] = useState([]);
  let [searchText, setSearchText] = useState("");
  let [loading, setLoading] = useState(false)
  let URL_GET_ADMINS = `${process.env.REACT_APP_API}${props.lista}/${user1.id}`;
  let USERPATCH = `${process.env.REACT_APP_API}editusers`;
  let excludeColumns = ["_id", "is_active", "createdAt", "password", "updatedAt",]; // excluye datos del arreglo del filtro
  let [show, setShow] = useState(false);
  let [show2, setShow2] = useState(false);
  let [show3, setShow3] = useState(false);
  let handleClose = () => setShow(false);
  let handleClose2 = () => setShow2(false);
  let handleClose3 = () => setShow3(false);
  const handleShow = () => setShow(true);
  const handleShow2 = () => setShow2(true);
  const handleShow3 = () => setShow3(true);
  let [citasUsuario, setCitasUsuario] = useState([])
  let [listaCancelaciones, setListaCancelaciones] = useState([])
  let [pacienteID, setPacienteID] = useState("")
  let [fechaInicio, setFechaInicio] = useState(null);
  let [fechaFin, setFechaFin] = useState(null);
  let [visible, setVisible] = useState(false);

  // handle change event of search input
  const handleChange = (value) => {
    setSearchText(value);
    filterData(value);
  };

  useEffect(() => {
    setLoading(true)
    if (user1.id !== undefined) {
      axios
        .get(URL_GET_ADMINS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then(
          // eslint-disable-next-line
          (data) => (setUsers(data.data), setData1(data.data), setSearchText(""), setLoading(false))
        )
        .catch((err) => console.log(err));

      axios.get(`${process.env.REACT_APP_API}doctors/${user1.id}`, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}`, }, })
        .then((res) => { setDoctores(res.data); })
        .catch((error) => {
          console.error('Error al traer doctores:', error);
        });
    }
    // eslint-disable-next-line
  }, [user1]);

  useEffect(() => {
    verify();
    // eslint-disable-next-line
  }, [data1]);

  const verify = () => {
    if (list === "admins") {
      setList("admins");
    }
    if (list === "doctors") {
      setList("doctors");
    }
    if (list === "secres") {
      setList("secres");
    }
    if (list === "usuarios") {
      setList("usuarios");
    }
  };

  // filter records by search text
  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue === "") setData1(users);
    else {
      const filteredData = users.filter((item) => {
        return Object.keys(item).some((key) =>
          excludeColumns.includes(key)
            ? false
            : String(item[key]).toLowerCase().includes(lowercasedValue)
        );
      });
      setData1(filteredData);
    }
  };

  const sortJSON = (json, key, orden) => {
    // eslint-disable-next-line
    return json.sort(function (a, b) {
      var x = a[key],
        y = b[key];

      if (orden === "asc") {
        return x < y ? -1 : x > y ? 1 : 0;
      }

      if (orden === "desc") {
        return x > y ? -1 : x < y ? 1 : 0;
      }
    });
  };

  function eliminarCita(item) {

    let listaCancelacionesNueva = listaCancelaciones.filter((v) => v !== item)

    axios.patch(`${USERPATCH}/${user1.id}/${pacienteID}`, { listaCancelaciones: listaCancelacionesNueva },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Se elimino con exito',
          showConfirmButton: false,
          timer: 1500
        })
        let indexUsuario = data1.findIndex(x => x._id == pacienteID)
        data1[indexUsuario].listaCancelaciones = listaCancelacionesNueva
        setShow2(false)
        setData1([...data1])
      })
      .catch((error) => console.log(error))

  }

  function castigar(user) {
    if (user.castigado) {
      // Si ya está castigado, preguntar si quieres quitar el castigo
      Swal.fire({
        title: '¿Quitar castigo?',
        text: `${user.nombre} ${user.apellido} está castigado por ${user.mesesCastigo || 0} meses. ¿Quieres quitar el castigo?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, quitar castigo',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            castigado: false,
            mesesCastigo: 0
          };

          axios.patch(`${USERPATCH}/${user1.id}/${user._id}`, payload,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((res) => {
              const indexUsuario = data1.findIndex(x => x._id === user._id);
              if (indexUsuario !== -1) {
                const newData = [...data1];
                newData[indexUsuario] = {
                  ...newData[indexUsuario],
                  castigado: false,
                  mesesCastigo: 0
                };
                setData1(newData);
              }
              Swal.fire('Castigo removido', `El castigo de ${user.nombre} ha sido removido`, 'success');
            })
            .catch((error) => {
              console.log(error);
              Swal.fire('Error', 'No se pudo quitar el castigo', 'error');
            });
        }
      });
    } else {
      // Si no está castigado, mostrar opciones de meses
      Swal.fire({
        title: 'Castigar usuario',
        text: `¿Por cuántos meses quieres castigar a ${user.nombre} ${user.apellido}?`,
        icon: 'warning',
        input: 'select',
        inputOptions: {
          '1': '1 mes',
          '2': '2 meses',
          '3': '3 meses',
          '4': '4 meses',
          '5': '5 meses',
          '6': '6 meses',
          '9': '9 meses',
          '12': '12 meses'
        },
        inputPlaceholder: 'Selecciona los meses',
        showCancelButton: true,
        confirmButtonText: 'Castigar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          const meses = parseInt(result.value);

          const payload = {
            castigado: true,
            mesesCastigo: meses
          };

          axios.patch(`${USERPATCH}/${user1.id}/${user._id}`, payload,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((res) => {
              const indexUsuario = data1.findIndex(x => x._id === user._id);
              if (indexUsuario !== -1) {
                const newData = [...data1];
                newData[indexUsuario] = {
                  ...newData[indexUsuario],
                  castigado: true,
                  mesesCastigo: meses
                };
                setData1(newData);
              }
              Swal.fire('Usuario castigado', `${user.nombre} ha sido castigado por ${meses} meses`, 'success');
            })
            .catch((error) => {
              console.log(error);
              Swal.fire('Error', 'No se pudo castigar al usuario', 'error');
            });
        }
      });
    }
  }

  sortJSON(data1, order, "asc");

  const data = dataxls;
  const fileName = "ReporteContactos";
  const exportType = "csv";

  const xls = () => {
    exportFromJSON({ data, fileName, exportType });
  };

  useEffect(() => {
    let list1 = list;
    if (list1 === "admins") {
      let fname = data1.map((v) => v.nombre);
      let lname = data1.map((v) => v.apellido);
      let email = data1.map((v) => v.email);
      let tel = data1.map((v) => v.celular);

      let datos = [];

      for (var i = 0; i < fname.length; i++) {
        datos.push({
          Nombre: fname[i],
          Apellido: lname[i],
          Email: email[i],
          Telefono: tel[i],
        });
        setDataxls(datos);
      }
    } else if (list1 === "doctors") {
      let fname = data1.map((v) => v.nombre);
      let lname = data1.map((v) => v.apellido);
      let country = data1.map((v) => v.country);
      let specialty = data1.map((v) => v.specialty);
      let email = data1.map((v) => v.email);
      let tel = data1.map((v) => v.celular);

      let datos = [];

      for (let i = 0; i < fname.length; i++) {
        datos.push({
          Nombre: fname[i],
          Apellido: lname[i],
          Pais: country[i],
          Especialidad: specialty[i],
          Email: email[i],
          Telefono: tel[i],
        });
        setDataxls(datos);
      }
    }
    else if (list1 === "secres") {
      let fname = data1.map((v) => v.nombre);
      let lname = data1.map((v) => v.apellido);
      let email = data1.map((v) => v.email);
      let tel = data1.map((v) => v.celular);

      let datos = [];

      for (let i = 0; i < fname.length; i++) {
        datos.push({
          Nombre: fname[i],
          Apellido: lname[i],
          Email: email[i],
          Telefono: tel[i],
        });
        setDataxls(datos);
      }
    } else if (list1 === "usuarios") {
      let fname = data1.map((v) => v.nombre);
      let lname = data1.map((v) => v.apellido);
      let age = data1.map((v) => v.age);
      let country = data1.map((v) => v.country);
      let comunity = data1.map((v) => v.comunity);
      let email = data1.map((v) => v.email);
      let tel = data1.map((v) => v.celular);

      let datos = [];

      for (let i = 0; i < fname.length; i++) {
        datos.push({
          Nombre: fname[i],
          Apellido: lname[i],
          Edad: age[i],
          Pais: country[i],
          Comunidad: comunity[i],
          Email: email[i],
          Telefono: tel[i],
        });
        setDataxls(datos);
      }
    }
    // eslint-disable-next-line
  }, [data1]);

  const exportarCuentasExcel = (pacientes, fechaInicio = null, fechaFin = null) => {
    const datosDetallados = [];

    let totalCargosGeneral = 0;
    let totalPagosGeneral = 0;
    let totalCopagosGeneral = 0;
    let totalSaldoGeneral = 0;

    // Función para convertir fecha a objeto Date (maneja múltiples formatos)
    const parsearFecha = (fechaStr) => {
      if (!fechaStr) return null;

      // Si ya es un objeto Date
      if (fechaStr instanceof Date) {
        return new Date(fechaStr);
      }

      // Si es string, limpiar espacios
      if (typeof fechaStr === 'string') {
        fechaStr = fechaStr.trim();

        // Intentar parsear DD-MM-YYYY o DD/MM/YYYY
        const partes = fechaStr.split(/[-/]/);
        if (partes.length === 3) {
          let dia, mes, año;

          // Detectar si es YYYY-MM-DD o DD-MM-YYYY
          if (partes[0].length === 4) {
            // Formato: YYYY-MM-DD
            año = parseInt(partes[0]);
            mes = parseInt(partes[1]) - 1;
            dia = parseInt(partes[2]);
          } else {
            // Formato: DD-MM-YYYY o MM-DD-YYYY
            // Asumimos DD-MM-YYYY (formato europeo)
            dia = parseInt(partes[0]);
            mes = parseInt(partes[1]) - 1;
            año = parseInt(partes[2]);
          }

          if (!isNaN(dia) && !isNaN(mes) && !isNaN(año)) {
            const fecha = new Date(año, mes, dia);
            if (!isNaN(fecha.getTime())) {
              return fecha;
            }
          }
        }
      }

      // Último intento: dejar que JavaScript lo intente
      try {
        const fecha = new Date(fechaStr);
        if (!isNaN(fecha.getTime())) {
          return fecha;
        }
      } catch (e) {
        // Ignorar
      }

      return null;
    };

    // Función para verificar si una fecha está dentro del rango
    const estaEnRango = (fechaStr) => {
      // Si no hay filtros, mostrar todo
      if (!fechaInicio && !fechaFin) return true;

      // Si la fecha es null o undefined, no está en rango
      if (!fechaStr) return false;

      const fecha = parsearFecha(fechaStr);
      if (!fecha) return false;

      // Resetear horas para comparar solo fechas
      fecha.setHours(0, 0, 0, 0);

      // Verificar fecha inicio
      if (fechaInicio) {
        const inicio = parsearFecha(fechaInicio);
        if (!inicio) return false;
        inicio.setHours(0, 0, 0, 0);
        if (fecha < inicio) return false;
      }

      // Verificar fecha fin
      if (fechaFin) {
        const fin = parsearFecha(fechaFin);
        if (!fin) return false;
        fin.setHours(23, 59, 59, 999);
        if (fecha > fin) return false;
      }

      return true;
    };

    // Función para obtener el nombre completo del odontólogo
    const obtenerNombreOdontologo = (odontologo) => {
      if (!odontologo) return 'Sin odontólogo';

      if (typeof odontologo === 'object') {
        const nombre = odontologo.nombre || '';
        const apellido = odontologo.apellido || '';
        return `${nombre} ${apellido}`.trim() || 'Sin odontólogo';
      }

      return odontologo;
    };

    // Recorrer cada paciente
    pacientes.forEach((paciente) => {
      paciente.cuenta?.forEach((cuenta) => {

        // --- PROCESAR CARGOS ---
        cuenta.cargos?.forEach((cargo) => {
          const fecha = cargo.fecha || cargo.createdAt;

          if (estaEnRango(fecha)) {
            const monto = Number(cargo.cantidad) || Number(cargo.monto) || 0;
            if (monto > 0) {
              const odontologo = cargo.odontologo || null;
              const nombreOdontologo = obtenerNombreOdontologo(odontologo);
              const tratamiento = cargo.tratamiento || cuenta.tratamiento || 'Sin especificar';

              datosDetallados.push({
                "Paciente": `${paciente.apellido} ${paciente.nombre}`.trim().toUpperCase(),
                "DNI": paciente.dni || '',
                "Odontólogo": nombreOdontologo,
                "Tratamiento": tratamiento,
                "Tipo": "CARGO",
                "Monto": monto,
                "Fecha": fecha || '',
                "Obra Social": paciente.obraSocial || '',
                "Saldo del Tratamiento": 0
              });

              totalCargosGeneral += monto;
            }
          }
        });

        // --- PROCESAR PAGOS ---
        cuenta.pagos?.forEach((pago) => {
          const fecha = pago.fecha || pago.createdAt;

          if (estaEnRango(fecha)) {
            const monto = Number(pago.cantidad) || Number(pago.monto) || 0;
            if (monto > 0) {
              const tratamiento = pago.tratamiento || cuenta.tratamiento || 'Sin especificar';

              // Buscar el odontólogo en los cargos del mismo tratamiento
              const cargoRelacionado = cuenta.cargos?.find(
                (c) => (c.tratamiento || cuenta.tratamiento) === tratamiento
              );
              const odontologo = pago.odontologo || cargoRelacionado?.odontologo || null;
              const nombreOdontologo = obtenerNombreOdontologo(odontologo);

              datosDetallados.push({
                "Paciente": `${paciente.apellido} ${paciente.nombre}`.trim().toUpperCase(),
                "DNI": paciente.dni || '',
                "Odontólogo": nombreOdontologo,
                "Tratamiento": tratamiento,
                "Tipo": "PAGO",
                "Forma de Pago": pago.formaPago || '',
                "Monto": monto,
                "Fecha": fecha || '',
                "Obra Social": paciente.obraSocial || '',
                "Saldo del Tratamiento": 0
              });

              totalPagosGeneral += monto;
            }
          }
        });

        // --- PROCESAR COPAGOS ---
        cuenta.copagos?.forEach((copago) => {
          const fecha = copago.fecha || copago.createdAt;

          if (estaEnRango(fecha)) {
            const monto = Number(copago.cantidad) || Number(copago.monto) || 0;
            if (monto > 0) {
              const tratamiento = copago.tratamiento || cuenta.tratamiento || 'Sin especificar';

              // El copago trae su propio odontólogo
              const odontologo = copago.odontologo || null;
              const nombreOdontologo = obtenerNombreOdontologo(odontologo);

              datosDetallados.push({
                "Paciente": `${paciente.apellido} ${paciente.nombre}`.trim().toUpperCase(),
                "DNI": paciente.dni || '',
                "Odontólogo": nombreOdontologo,
                "Tratamiento": tratamiento,
                "Tipo": "COPAGO",
                "Forma de Pago": copago.formaPago || '',
                "Monto": monto,
                "Fecha": fecha || '',
                "Obra Social": paciente.obraSocial || '',
                "Saldo del Tratamiento": 0
              });

              totalCopagosGeneral += monto;
            }
          }
        });

      });
    });

    // --- CALCULAR SALDO POR TRATAMIENTO ---
    const agrupador = {};
    datosDetallados.forEach(item => {
      const key = `${item.Paciente}|${item.Odontólogo}|${item.Tratamiento}`;
      if (!agrupador[key]) {
        agrupador[key] = {
          cargos: 0,
          pagos: 0,
          copagos: 0,
          items: []
        };
      }
      agrupador[key].items.push(item);
      if (item.Tipo === 'CARGO') agrupador[key].cargos += item.Monto;
      if (item.Tipo === 'PAGO') agrupador[key].pagos += item.Monto;
      if (item.Tipo === 'COPAGO') agrupador[key].copagos += item.Monto;
    });

    // Actualizar cada item con el saldo de su tratamiento
    datosDetallados.forEach(item => {
      const key = `${item.Paciente}|${item.Odontólogo}|${item.Tratamiento}`;
      const grupo = agrupador[key];
      if (grupo) {
        const saldoTratamiento = grupo.cargos - grupo.pagos;
        item["Saldo del Tratamiento"] = saldoTratamiento;
      }
    });

    // Ordenar por Paciente, Odontólogo, Tratamiento y Fecha
    datosDetallados.sort((a, b) => {
      if (a.Paciente !== b.Paciente) return a.Paciente.localeCompare(b.Paciente);
      if (a.Odontólogo !== b.Odontólogo) return a.Odontólogo.localeCompare(b.Odontólogo);
      if (a.Tratamiento !== b.Tratamiento) return a.Tratamiento.localeCompare(b.Tratamiento);
      return (a.Fecha || '').localeCompare(b.Fecha || '');
    });

    // Calcular totales generales
    totalSaldoGeneral = totalCargosGeneral - totalPagosGeneral;

    // Agregar filas de totales
    if (datosDetallados.length > 0) {
      datosDetallados.push({
        "Paciente": "===== TOTALES GENERALES =====",
        "DNI": "",
        "Odontólogo": "",
        "Tratamiento": "",
        "Tipo": "",
        "Forma de Pago": "",
        "Monto": "",
        "Fecha": "",
        "Obra Social": "",
        "Saldo del Tratamiento": ""
      });

      datosDetallados.push({
        "Paciente": "TOTAL CARGOS",
        "DNI": "",
        "Odontólogo": "",
        "Tratamiento": "",
        "Tipo": "",
        "Forma de Pago": "",
        "Monto": totalCargosGeneral,
        "Fecha": "",
        "Obra Social": "",
        "Saldo del Tratamiento": ""
      });

      datosDetallados.push({
        "Paciente": "TOTAL PAGOS",
        "DNI": "",
        "Odontólogo": "",
        "Tratamiento": "",
        "Tipo": "",
        "Forma de Pago": "",
        "Monto": totalPagosGeneral,
        "Fecha": "",
        "Obra Social": "",
        "Saldo del Tratamiento": ""
      });

      datosDetallados.push({
        "Paciente": "SALDO TOTAL",
        "DNI": "",
        "Odontólogo": "",
        "Tratamiento": "",
        "Tipo": "",
        "Forma de Pago": "",
        "Monto": totalSaldoGeneral,
        "Fecha": "",
        "Obra Social": "",
        "Saldo del Tratamiento": ""
      });

      if (totalCopagosGeneral > 0) {
        datosDetallados.push({
          "Paciente": "TOTAL COPAGOS",
          "DNI": "",
          "Odontólogo": "",
          "Tratamiento": "",
          "Tipo": "",
          "Forma de Pago": "",
          "Monto": totalCopagosGeneral,
          "Fecha": "",
          "Obra Social": "",
          "Saldo del Tratamiento": ""
        });
      }
    }

    // Crear libro de Excel
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(datosDetallados);
    worksheet["!cols"] = [
      { wch: 35 }, // Paciente
      { wch: 15 }, // DNI
      { wch: 35 }, // Odontólogo
      { wch: 30 }, // Tratamiento
      { wch: 12 }, // Tipo
      { wch: 18 }, // Monto
      { wch: 18 }, // Fecha
      { wch: 25 }, // Obra Social
      { wch: 22 }  // Saldo del Tratamiento
    ];

    XLSX.utils.book_append_sheet(workbook, worksheet, "Tratamientos");

    // --- GENERAR NOMBRE DEL ARCHIVO ---
    const fechaStr = new Date().toISOString().slice(0, 10);
    let rangoStr = '';

    // Función para formatear fecha a YYYY-MM-DD para el nombre del archivo
    const formatearFechaParaNombre = (fechaStr) => {
      if (!fechaStr) return null;
      const fecha = parsearFecha(fechaStr);
      if (!fecha) return null;
      const año = fecha.getFullYear();
      const mes = String(fecha.getMonth() + 1).padStart(2, '0');
      const dia = String(fecha.getDate()).padStart(2, '0');
      return `${año}-${mes}-${dia}`;
    };

    if (fechaInicio && fechaFin) {
      const inicio = formatearFechaParaNombre(fechaInicio);
      const fin = formatearFechaParaNombre(fechaFin);
      if (inicio && fin) {
        rangoStr = `_${inicio}_al_${fin}`;
      }
    } else if (fechaInicio) {
      const inicio = formatearFechaParaNombre(fechaInicio);
      if (inicio) {
        rangoStr = `_desde_${inicio}`;
      }
    } else if (fechaFin) {
      const fin = formatearFechaParaNombre(fechaFin);
      if (fin) {
        rangoStr = `_hasta_${fin}`;
      }
    }

    const nombreArchivo = `detalle_tratamientos${rangoStr}_${fechaStr}.xlsx`;

    XLSX.writeFile(workbook, nombreArchivo);
  };
  const handleExportar = () => {
    const formatearFechaDDMMYYYY = (fecha) => {
      if (!fecha) return null;
      const dia = String(fecha.getDate()).padStart(2, '0');
      const mes = String(fecha.getMonth() + 1).padStart(2, '0');
      const año = fecha.getFullYear();
      return `${dia}-${mes}-${año}`;
    };

    const inicio = fechaInicio ? formatearFechaDDMMYYYY(fechaInicio) : null;
    const fin = fechaFin ? formatearFechaDDMMYYYY(fechaFin) : null;

    exportarCuentasExcel(data1, inicio, fin);
  };

  // Manejar el cambio de rango de fechas
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setFechaInicio(start);
    setFechaFin(end);
  };

  return (
    <>
      <Modal size="xl" show={show}>
        <Modal.Header>
          <Modal.Title>Historial de turnos</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <div className="container">
            <div className="row">
              <div className="col-12">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Fecha</th>
                      <th scope="col">Hora</th>
                      <th scope="col">Profesional</th>
                      <th scope="col">Motivo</th>
                      <th scope="col">Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      citasUsuario.map((cita, i) => (
                        <tr key={i}>
                          <th scope="row">{dayjs(cita.date).format("DD/MM/YYYY")}</th>
                          <td>{cita.time}</td>
                          <td>{cita.profesional[0].nombre.toLowerCase().replace(/^\w/, c => c.toUpperCase())} {cita.profesional[0].apellido.toLowerCase().replace(/^\w/, c => c.toUpperCase())}</td>
                          <td>{cita.note}</td>
                          <td>{cita.asistio === "si" ? "Realizada" : cita.asistio === "no" ? "Ausente" : "Pendiente"}</td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </Modal.Body>

        <Modal.Footer><Button variant="secondary" onClick={handleClose}>Cerrar</Button></Modal.Footer>

      </Modal>

      <Modal size="sm" show={show2}>
        <Modal.Header>
          <Modal.Title>{listaCancelaciones.filter(cita => dayjs(cita.split(" ")[0]).isAfter(dayjs().subtract(3, "month"))).length} Canceladas</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Fecha</th>
                <th scope="col">Hora</th>
                <th scope="col">Eliminar</th>
              </tr>
            </thead>
            <tbody>
              {
                listaCancelaciones.filter(cita => dayjs(cita.split(" ")[0]).isAfter(dayjs().subtract(3, "month"))).map((cita, i) => (
                  <tr key={i}>
                    <th>{dayjs(cita.split(" ")[0]).format("DD/MM/YYYY")}</th>
                    <th>{cita.split(" ")[1]}</th>
                    <th><Button style={{ borderRadius: 10 }} variant="danger" onClick={() => eliminarCita(cita)}>< i className="far fa-trash-alt"></i></Button></th>
                  </tr>
                ))
              }
            </tbody>
          </table>

        </Modal.Body>

        <Modal.Footer><Button variant="secondary" onClick={handleClose2}>Cerrar</Button></Modal.Footer>

      </Modal>

      <Modal size="sm" show={show3}>
        <Modal.Header>
          <Modal.Title>{listaCancelaciones.length} Ausencias</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Fecha</th>
                <th scope="col">Hora</th>
              </tr>
            </thead>
            <tbody>
              {
                listaCancelaciones.map((cita, i) => (
                  <tr key={i}>
                    <th>{dayjs(cita.split(" ")[0]).format("DD/MM/YYYY")}</th>
                    <th>{cita.split(" ")[1]}</th>
                  </tr>
                ))
              }
            </tbody>
          </table>

        </Modal.Body>

        <Modal.Footer><Button variant="secondary" onClick={handleClose3}>Cerrar</Button></Modal.Footer>

      </Modal>

      <Modal size="md" show={visible} onHide={() => setVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Descargar caja por fechas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
            <DatePicker
              selectsRange={true}
              startDate={fechaInicio}
              endDate={fechaFin}
              onChange={handleDateChange}
              dateFormat="dd/MM/yyyy"
              placeholderText="Rango de fechas"
              isClearable={true}
              className="custom-datepicker"
            />
            <Button variant="success" onClick={handleExportar}>Descargar archivo <i className="far fa-file-excel"></i></Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setVisible(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {isAuth ? (
        <div className="noprint">
          <Header />
          <br />
          <Row>
            <Col>
              <h1 className="margin">{props.titulo}</h1>
            </Col>
            {user1.role === "admin" ?
              list !== "usuarios" ?
                <Col>
                  <Button
                    href={list === "admins" ? "/signupadmin" : list === "doctors" ? "/signupdoctor" : list === "secres" ? "/signupsecre" : null}
                    variant="success"
                    className="float"
                  >
                    Nuevo
                  </Button>
                </Col>
                : null
              : null}
          </Row>
          {user1.role === "admin" || user1.role === "secre" ?
            <div className="float">
              <Button variant="success" onClick={() => setVisible(true)} className="margin">Caja <i className="far fa-file-excel"></i></Button>
              <Button
                variant="outline-success rounded-circle "
                onClick={xls}
                className="margin"
              >
                {" "}
                <i className="far fa-file-excel"></i>
              </Button>
            </div>
            : null}
          <input
            className="w3-input w3-border w3-animate-input buscador"
            type="text"
            placeholder="Busqueda"
            value={searchText}
            onChange={(e) => handleChange(e.target.value)}
          ></input>
          {loading ?
            <center>
              <div className='loading'><ReactLoading type={'spin'} color={'cornflowerblue'} height={'5vw'} width={'5vw'} /></div>
            </center>
            :
            <TableVirtuoso
              style={{ height: "60vh" }}
              components={{ Table: ({ style, ...props }) => <Table hover {...props} style={{ ...style, width: "100%" }} /> }}
              data={data1}
              fixedHeaderContent={() => (
                <tr>
                  <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Nombre</th>
                  <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Apellido</th>
                  {list === "doctors" ?
                    <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Especialidad</th>
                    : null}
                  <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Email</th>
                  {list === "doctors" || list === "usuarios" || list === "secres" ?
                    user1.role === "admin" || user1.role === "secre" ?
                      <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Dni</th>
                      : null
                    : null}
                  <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Telefono</th>
                  {user1.role !== "user" && list === "usuarios" ?
                    <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Expediente</th>
                    : null}
                  {user1.role !== "user" && list === "usuarios" ?
                    <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Historial</th>
                    : null}
                  {user1.role === "doctor" || user1.role === "secre" ?
                    list === "usuarios" ?
                      <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Sobre Turno</th>
                      : null
                    : null}
                  {list === "admins" ? null :
                    <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Acciones</th>
                  }
                </tr>
              )}
              itemContent={(index, user) => (
                <>
                  {
                    user.is_active &&
                    <>
                      <td style={{ textAlign: 'center', minWidth: '20vh', maxWidth: '20vh' }}>{user.nombre.toLowerCase().replace(/^\w/, c => c.toUpperCase())}</td>
                      <td style={{ textAlign: 'center', minWidth: '20vh', maxWidth: '20vh' }}>{user.apellido.toLowerCase().replace(/^\w/, c => c.toUpperCase())}</td>
                      {list === "doctors" ?
                        <td style={{ textAlign: 'center' }}>{user.especialidad.map((item) => item + " ")}</td>
                        : null}
                      <td style={{ textAlign: 'center', minWidth: '40vh', maxWidth: '40vh' }}>{user.email}</td>
                      {list === "doctors" || list === "usuarios" || list === "secres" ?
                        user1.role === "admin" || user1.role === "secre" ?
                          <td style={{ textAlign: 'center', minWidth: '15vh', maxWidth: '15vh' }}>{user.dni}</td>
                          : null
                        : null}
                      <td style={{ textAlign: 'center', minWidth: '15vh', maxWidth: '15vh' }}>{user.celular}</td>
                      {user1.role !== "user" && list === "usuarios" ?
                        <td style={{ textAlign: 'center' }}><Expediente user={user} /></td>
                        : null}
                      {user1.role !== "user" && list === "usuarios" ?
                        <td style={{ textAlign: 'center' }}>
                          <div className="centrado">
                            <OverlayTrigger
                              placement="top" // La posición del tooltip (puede ser "top", "bottom", "left", "right")
                              overlay={<Tooltip id="button-tooltip">Historial de turnos</Tooltip>}
                            >
                              <Button onClick={() => {
                                handleShow()
                                axios.get(`${process.env.REACT_APP_API}schedulesbyuser/${user1.id}/${user._id}`,
                                  {
                                    headers: {
                                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                                    },
                                  })
                                  .then((res) => {
                                    setCitasUsuario(res.data.sort((a, b) => new Date(a.date) - new Date(b.date)))
                                  })
                                  .catch((err) => {
                                    console.log(err)
                                  })
                              }}><i className="fa-solid fa-calendar-days"></i></Button>
                            </OverlayTrigger>
                          </div>
                        </td>
                        : null
                      }
                      {user1.role === "doctor" || user1.role === "secre" ?
                        list === "usuarios" ?
                          <td style={{ textAlign: 'center' }}>
                            <SobreTurno
                              id={user._id}
                              nombre={user.nombre.toLowerCase().replace(/^\w/, c => c.toUpperCase())}
                              apellido={user.apellido.toLowerCase().replace(/^\w/, c => c.toUpperCase())}
                            />
                          </td>
                          : null
                        : null
                      }
                      {list === "admins" ? null :
                        <td style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', flexDirection: 'row', gap: '10px' }}>
                          {
                            user.role === "user" &&
                            <>
                              <Cuenta user={user} data1={data1} setData1={setData1} doctores={doctores} />
                              <OverlayTrigger
                                placement="top" // La posición del tooltip (puede ser "top", "bottom", "left", "right")
                                overlay={<Tooltip id="button-tooltip">Historial de cancelaciones</Tooltip>}
                              >
                                <Button variant="warning" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '40px', maxWidth: '40px' }} onClick={() => {
                                  handleShow2()
                                  setListaCancelaciones(user.listaCancelaciones)
                                  setPacienteID(user._id)
                                }}>{user.listaCancelaciones.filter(cita => dayjs(cita.split(" ")[0]).isAfter(dayjs().subtract(3, "month"))).length}</Button>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="top" // La posición del tooltip (puede ser "top", "bottom", "left", "right")
                                overlay={<Tooltip id="button-tooltip">Historial de ausencias</Tooltip>}
                              >
                                <Button variant="danger" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '40px', maxWidth: '40px' }} onClick={() => {
                                  handleShow3()
                                  axios.get(`${process.env.REACT_APP_API}schedulesbyuser/${user1.id}/${user._id}`, {
                                    headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
                                  })
                                    .then((res) => {
                                      const hoy = new Date();
                                      const haceUnAnio = new Date();
                                      haceUnAnio.setFullYear(hoy.getFullYear() - 1);

                                      const cancelaciones = res.data
                                        .filter((item) => item.asistio === "no")
                                        .filter((item) => {
                                          const fechaTurno = new Date(`${item.date.slice(0, 10)}T${item.time}:00`);
                                          return fechaTurno >= haceUnAnio && fechaTurno <= hoy;
                                        })
                                        .sort((a, b) => new Date(a.date) - new Date(b.date))
                                        .map((item) => `${item.date.slice(0, 10)} ${item.time}`);

                                      setListaCancelaciones(cancelaciones);
                                    })
                                    .catch((err) => { console.log(err); });
                                  // setListaCancelaciones(user.listaCancelaciones)
                                  setPacienteID(user._id)
                                }}><i className="fa-solid fa-eye"></i></Button>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="top" // La posición del tooltip (puede ser "top", "bottom", "left", "right")
                                overlay={<Tooltip id="button-tooltip">Castigado</Tooltip>}
                              >
                                <Button
                                  variant={user.castigado ? "dark" : "success"}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minWidth: '40px',
                                    maxWidth: '40px',
                                    position: 'relative'
                                  }}
                                  onClick={() => { castigar(user) }}
                                  title={user.castigado ? `Castigado por ${user.mesesCastigo || 0} meses` : 'Usuario activo'}
                                >
                                  {user.castigado ? (
                                    <>
                                      <i className="fa-solid fa-user-xmark"></i>
                                      {user.mesesCastigo > 0 && (
                                        <span style={{
                                          position: 'absolute',
                                          top: '-8px',
                                          right: '-8px',
                                          background: 'red',
                                          color: 'white',
                                          borderRadius: '50%',
                                          width: '20px',
                                          height: '20px',
                                          fontSize: '11px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          fontWeight: 'bold'
                                        }}>
                                          {user.mesesCastigo}
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    <i className="fa-solid fa-user-check"></i>
                                  )}
                                </Button>
                                {/* <Button variant={user.castigado ? "dark" : "success"} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '40px', maxWidth: '40px' }} onClick={() => { castigar(user) }}>{user.castigado ? <i className="fa-solid fa-user-xmark"></i> : <i className="fa-solid fa-user-check"></i>}</Button> */}
                              </OverlayTrigger>
                            </>
                          }
                          <BotComment
                            id={user._id}
                            first_name={user.nombre.toLowerCase().replace(/^\w/, c => c.toUpperCase())}
                            last_name={user.apellido.toLowerCase().replace(/^\w/, c => c.toUpperCase())}
                          />
                          {/* <DisableUser
                            id={user._id}
                            first_name={user.nombre.toLowerCase().replace(/^\w/, c => c.toUpperCase())}
                            last_name={user.apellido.toLowerCase().replace(/^\w/, c => c.toUpperCase())}
                          /> */}
                        </td>
                      }
                    </>
                  }
                </>
              )
              }
            />

          }
        </div>
      ) : undefined}
    </>
  );
}

export default List;